import { mapDTO } from '@twistezo/ts-dto-mapper'

import { JSON_SPACE } from 'constants/json'
import { AdUnitDTO } from 'features/inventory/api/types/adUnitDTO'
import { AdUnit } from 'features/inventory/types/adUnit'
import { DomainRichPlacementMultiAnchor } from '../../types/domainRichPlacementMultiAnchor'
import { DomainRichPlacementMultiAnchorConfigurationDTO } from '../types/domainRichPlacementMultianchorConfigurationDTO'

type From = DomainRichPlacementMultiAnchorConfigurationDTO
type To = DomainRichPlacementMultiAnchor

export const domainRichPlacementMultiAnchorFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const {
      adUnits,
      customizeApperanceEnabled,
      customizeBasicSettingsEnabled,
      customStyling,
      displayAfterUserInteractionEnabled,
      enabled,
      fullWidthModeEnabled,
      showCloseButtonEnabled,
      singleAdViewTime,
    } = data

    return {
      adUnitIds: adUnits.map((adUnit: Pick<AdUnitDTO, 'id'>): AdUnit['id'] => adUnit.id),
      customizeAppearance: customizeApperanceEnabled,
      customizeBasicSettings: customizeBasicSettingsEnabled,
      customStyling: JSON.stringify(customStyling, null, JSON_SPACE),
      displayAfterUserInteraction: displayAfterUserInteractionEnabled,
      enabled,
      fullWidthMode: fullWidthModeEnabled,
      showCloseButton: showCloseButtonEnabled,
      singleAdViewTime,
    }
  })
